



























import FormInput from "@/components/FormInput.vue";
import FormInputError from "@/components/FormInputError.vue";
import FormInputGroup from "@/components/FormInputGroup.vue";
import PrefixesPopular from "@/components/PrefixesPopular.vue";
import { Prefix, Key } from "@/types/debug-mode";
import GetPopularItems from "@/mixins/get-popular-items";
import FormValidation from "@/mixins/form-validation";
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    FormInput,
    FormInputError,
    FormInputGroup,
    PrefixesPopular,
  },
})
export default class PrefixesAdd extends Mixins(GetPopularItems, FormValidation) {
  created() {
    this.getPopularItems();
  }

  beforeDestroy() {
    this.cleanUpPopularItems();
  }

  @Getter("debugMode/popularPrefixes") popularPrefixes!: undefined | null | Key[];

  title = "Save";

  isSaving = false;

  nameError = "";

  initialPrefix: Prefix = { id: 0, name: "" };

  prefix = Object.assign({}, this.initialPrefix);

  save() {
    this.nameError = this.validateString(this.prefix.name);
    if (this.nameError) return;

    this.$ga.button("Add prefix (text field)");

    this.title = "Saving";
    this.isSaving = true;

    this.$store.dispatch("debugMode/addPrefix", this.prefix).then(() => {
      this.title = "Saved!";
      this.isSaving = false;
      setTimeout(() => {
        this.title = "Save";
        this.prefix = Object.assign({}, this.initialPrefix);
      }, 1000);
    });
  }
}
